import { Button, HFlex, Modal, Text, VGrid, useToasts } from 'tombac';
import { useUserDetails } from "../UserDetailsProvider";
import { useRotateApigeeDeveloperKey } from "../api/userManagementApiHooks";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const RotateUserApigeeKeyModal = ({
  isOpen,
  onRequestClose
}) => {
  const user = useUserDetails();
  const {
    addToast
  } = useToasts();
  const {
    isLoading,
    mutateAsync: rotateApigeeDeveloperKey
  } = useRotateApigeeDeveloperKey();
  const handleSave = async () => {
    rotateApigeeDeveloperKey({
      username: user.email
    }, {
      onError: async error => {
        console.error(error);
        const response = await error.json();
        addToast(response.message ? /*#__PURE__*/_jsx("div", {
          style: {
            overflowWrap: 'anywhere',
            paddingRight: '5px'
          },
          children: response.message
        }) : "Could not change user's API key", 'danger');
      },
      onSuccess() {
        addToast('the API key will change in a moment', 'success');
        onRequestClose();
      }
    });
  };
  return /*#__PURE__*/_jsx(Modal, {
    isOpen: isOpen,
    onRequestClose: onRequestClose,
    "data-sentry-element": "Modal",
    "data-sentry-component": "RotateUserApigeeKeyModal",
    "data-sentry-source-file": "RotateUserApigeeKeyModal.tsx",
    children: /*#__PURE__*/_jsxs(VGrid, {
      gap: 3,
      $p: "4sp",
      $pb: "3sp",
      "data-sentry-element": "VGrid",
      "data-sentry-source-file": "RotateUserApigeeKeyModal.tsx",
      "data-sentry-element": "VGrid",
      children: [/*#__PURE__*/_jsx(Text, {
        "data-sentry-element": "Text",
        "data-sentry-source-file": "RotateUserApigeeKeyModal.tsx",
        "data-sentry-element": "Text",
        children: " Are you sure you want to rotate API key?"
      }), /*#__PURE__*/_jsxs(HFlex, {
        "data-sentry-element": "HFlex",
        "data-sentry-source-file": "RotateUserApigeeKeyModal.tsx",
        "data-sentry-element": "HFlex",
        children: [/*#__PURE__*/_jsx(Button, {
          $ml: "auto",
          onClick: onRequestClose,
          variant: "flat",
          "data-sentry-element": "Button",
          "data-sentry-source-file": "RotateUserApigeeKeyModal.tsx",
          "data-sentry-element": "Button",
          children: "Cancel"
        }), /*#__PURE__*/_jsx(Button, {
          busy: isLoading,
          $ml: "1sp",
          onClick: handleSave,
          variant: "primary",
          "data-sentry-element": "Button",
          "data-sentry-source-file": "RotateUserApigeeKeyModal.tsx",
          "data-sentry-element": "Button",
          children: "Rotate"
        })]
      })]
    })
  });
};